import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { CommonService } from 'src/app/core/service/common-service/common.service';
import { UserService } from 'src/app/core/service/user-service/user.service';
import { ToastrService } from 'ngx-toastr';
import { Customer360DialogComponent } from 'src/app/modal/customer360-dialog/customer360-dialog.component';
import { MatDialog } from "@angular/material";
import { DatePipe } from "@angular/common";
import * as _moment from 'moment';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'LL',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-inbound-call',
  templateUrl: './inbound-call.component.html',
  styleUrls: ['./inbound-call.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
})

export class InboundCallComponent implements OnInit {
  searchChassis: FormControl = new FormControl();
  searchNumber: FormControl = new FormControl();
  searchRegisterationNo: FormControl = new FormControl();

  custDataForm: FormGroup;
  serviceForm: FormGroup;

  customerChassisList = <any>[];
  customerNumberList = <any>[];
  customerDetails = <any>[];
  fleetDetail = <any>[];

  serviceDetail = <any>[];
  doorstepServiceDetail = <any>[];
  selectedVehicle = <any>[];
  selectedDoorstepVehicle = <any>[];
  selectedService: string;
  callReason: number = 1;

  //vehicle type selection
  vehicleNumbers: any[] = [
    { value: 1, type: 'Chasis Number' },
    { value: 2, type: 'Registration Number' }
  ];

  //service type selection
  serviceTypes: any[] = [
    { value: 'FS1 - FREE SERVICE', type: 'FS1 - FREE SERVICE', code: 'FS1' },
    { value: 'FS2 - FREE SERVICE', type: 'FS2 - FREE SERVICE', code: 'FS2' },
    { value: 'FS3 - FREE SERVICE', type: 'FS3 - FREE SERVICE', code: 'FS3' },
    { value: 'ECS - EARLY CARE SERVICE', type: 'ECS - EARLY CARE SERVICE', code: 'ECS' },
    { value: 'PMS - PREVENTIVE MAINTENANCE SERVICE', type: 'PMS - PREVENTIVE MAINTENANCE SERVICE', code: 'PMS' },
  ];

  //miscellaneous service type selection
  miscellaneousServices: any[] = [
    { value: 'RUNNING REPAIR', type: 'RUNNING REPAIR/QUICK SERVICE', code: 'RR' },
    { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
  ];

  //call type selection
  callReasons: any[] = [
    { value: 1, type: 'Service' },
    { value: 2, type: 'Inquiry' }
  ];

  //Payment mode selection
  paymentMode: any[] = [
    { value: 'cash', type: 'Cash' },
    { value: 'Digital', type: 'Digital' }
  ];

  selectedVehicleType: any = 1;
  selectedChasis: string;
  selectedRegNumber: string;
  dateTimeExample = new Date();
  today: Date = new Date();
  minDate: Date = new Date();
  submitted: boolean;
  spinner: boolean;
  submittedService: boolean = false;
  clear: boolean;
  disableServiceType: boolean;
  workShops = <any>[];
  selectedWorkShop: string;
  searchOldType: string;
  searchCurrentType: string;
  disableDate: boolean;
  userId: string;
  rrStatus: string;
  rrDropdown: boolean;
  miscellaneousService:string;
  division: string;
  workshopAppointmentFlag: string;
  bayNo: string;
  workshopCodeFlag: boolean = true;

  //bay
  assignedBay: any;
  workShopBay: any = {};
  bayError: boolean = false;
  bayOpen: any;
  bayClose: any;
  bayMinToday: any;
  bayMaxToday: any;
  serviceHours: any;
  bayLayout: any = [];
  selectedBay: any = [];
  listBay: any = [];
  showBay: boolean = false;
  showBay1: boolean = false;
  selectedBayNo: any = '';
  bayEndTime: any;
  packagelist: any[] = [];
  fertCode: any;
  commentFlag: boolean = false;
  bayStartTime: string;
  selectedVin: string;
  vinList: string[] = [];
  serviceMintus: any;
  bookingandResheduleMaxDate: Date = new Date();

  //chartBar start
  public chartOptions: ChartOptions = {
    responsive: true,
    tooltips: {
      enabled: false
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            display: true
          },
          ticks: {
            beginAtZero: false,
            fontSize: 12,
            stepSize: 1,
            autoSkip: false
          }
        }
      ],
      yAxes: [{
        display: false,
        gridLines: {
          display: false
        }
      }]
    }
  };
  public chartLabels: any[] = [];
  public chartType: ChartType = 'horizontalBar';
  public chartLegend = false;
  public chartPlugins = [];
  public chartData: any = [];
  serviceCount: any;
    bookingDate : any;
    todayDate : any;

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private userService: UserService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    this.workShops = JSON.parse(localStorage.getItem('workshops'));
    this.selectedWorkShop = (this.workShops && this.workShops.length) ? this.workShops[0].workshopCode : '';
    this.bookingandResheduleMaxDate.setDate(this.bookingandResheduleMaxDate.getDate() + 15);
    this.dateTimeExample.setDate(this.dateTimeExample.getDate() + 1);
    this.minDate = moment().add(1, 'd').set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })

    //chassis search auto complete
    this.searchChassis.valueChanges.subscribe(
      term => {
        if (term != '' && term.length > 3) {
          if (this.searchOldType !== this.searchCurrentType) {
            this.searchNumber.setValue('');
            this.searchRegisterationNo.setValue('');
            this.customerNumberList = [];
          }
          this.userService.searchChassis(term).subscribe(
            data => {
              if (data["responseCode"] == 0) {
                this.customerChassisList = data['responseData'] as any[];
                if (!this.customerChassisList.length) {
                  this.toastr.info(data['message'], "Info");
                }
              } else {
                this.toastr.error(data['message'], "Error");
              }
            }, err => {
              this.toastr.error("Something went wrong, Please try again.", "Error");
            });
        }
      });

    //customer number search auto complete
    this.searchNumber.valueChanges.subscribe(
      term => {
        if (term != '' && term.length > 9) {
          if (this.searchOldType !== this.searchCurrentType) {
            this.searchChassis.setValue('');
            this.searchRegisterationNo.setValue('');
            this.customerChassisList = [];
          }
          this.userService.searchContact(term).subscribe(
            data => {
              if (data["responseCode"] == 0) {
                this.customerNumberList = data['responseData'] as any[];
                if (this.customerNumberList.length) {
                  this.customerNumberList.forEach(function (value) {
                    value.customerContactNo = term;
                  });
                }
              } else {
                this.toastr.error(data['message'], "Error");
              }
            }, err => {
              this.toastr.error("Something went wrong, Please try again.", "Error");
            });
        }
      });
    this.getWorkshopBay();
  }

  /**
  * Name: searchReg
  * purpose: To search customer with reg number
  */
  searchReg() {
    this.spinner = true;
    this.showBay = false;
    this.showBay1= false;
    let term = this.searchRegisterationNo.value;
    if (term != '' && term.length > 3) {
      if (this.searchOldType !== this.searchCurrentType) { //clear other search data
        this.searchChassis.setValue('');
        this.searchNumber.setValue('');
        this.customerChassisList = [];
        this.customerNumberList = [];
      }
      this.userService.searchCustomer(term, 'R', this.userId).subscribe(
        data => {
          if (data["responseCode"] == 0) {
            this.spinner = false;
            this.customerDetails = data['responseData'];
            // this.customerDetails.forEach((element) => {
            //   this.vinList.push(element.vin);
            // });
            this.selectedVin = this.customerDetails[0].vin
            localStorage.setItem("selectedVin",this.selectedVin);
            if (this.customerDetails && this.customerDetails[0].customerCode) {
              this.buildCustDataForm();
              this.getFleetDetails(this.customerDetails[0].customerCode);
              this.getServiceDetails(this.customerDetails[0].customerCode, this.selectedVin);
            }
          } else {
            this.spinner = false;
            this.toastr.error(data['message'], "Error");
          }
        }, err => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    }
  }

  /**
  * Name: selectCustomer
  * purpose: To select customer from search
  * @param {string} value - selected customer
  * @param {string} flag - customer search type
  */
  selectCustomer(value: string, flag: string) {
    this.showBay = false;
    this.showBay1= false;
    this.spinner = true;
    this.searchOldType = flag;
    this.userService.searchCustomer(value, flag, this.userId).subscribe(
      data => {
        if (data["responseCode"] == 0) {
          this.customerDetails = data['responseData'];
          this.customerDetails.forEach((element) => {
            this.vinList.push(element.vin);
          });
          this.selectedVin = this.customerDetails[0].vin
          localStorage.setItem("selectedVin",this.selectedVin);
          if (this.customerDetails && this.customerDetails[0].customerCode) {
            this.buildCustDataForm();
            this.getFleetDetails(this.customerDetails[0].customerCode);
            this.getServiceDetails(this.customerDetails[0].customerCode, this.customerDetails[0].vin);
          }
        } else {
          this.toastr.error(data['message'], "Error");
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: getFleetDetails
  * purpose: To get fleet details
  * @param {string} customerCode - selected customer code
  */
  getFleetDetails(customerCode: string) {
    this.spinner = true;
    this.userService.getFleetDetail(customerCode).subscribe(
      data => {
        if (data["responseCode"] == 0) {
          this.fleetDetail = data['responseData'];
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: getServiceDetails
  * purpose: To get vehicle service details
  * @param {string} customerCode - selected customer code
  */
  getServiceDetails(customerCode: string, vin: string) {
    this.spinner = true;
    this.userService.getServiceDetail(customerCode, this.userId, vin).subscribe(
      data => {
        if (data["responseCode"] == 0) {
          this.serviceDetail = data['responseData'];
          if (this.searchChassis.value) {//if search is chasis then select default vehicle
            let filterVehicle = this.serviceDetail.filter(vehicle => vehicle.vin == this.searchChassis.value)[0];
            this.selectedChasis = filterVehicle.vin;
            this.selectedRegNumber = filterVehicle.registrationNumber
            this.selectedVehicle = filterVehicle;
            this.selectedService = filterVehicle.typeOfService;
            this.selectedWorkShop = filterVehicle.workshopCode || this.selectedWorkShop;
            this.selectedVehicleType = 1;
            this.rrStatus = filterVehicle.rrStatus;
            this.division = filterVehicle.division;
            this.serviceCount = filterVehicle.serviceTypeSequence;
            // this.bayNo = filterVehicle.bayNo;
            // this.bayStartTime = filterVehicle.bayStartTime;
            // this.bayEndTime = filterVehicle.bayEndTime;
          } else if (this.searchRegisterationNo.value) {//if search is registrationNumber then select default vehicle
            let filterVehicle = this.serviceDetail.filter(vehicle => vehicle.registrationNumber == this.searchRegisterationNo.value)[0];
            this.selectedChasis = filterVehicle.vin
            this.selectedRegNumber = filterVehicle.registrationNumber
            this.selectedVehicle = filterVehicle;
            this.selectedService = filterVehicle.typeOfService;
            this.selectedWorkShop = filterVehicle.workshopCode || this.selectedWorkShop;
            this.selectedVehicleType = 2;
            this.rrStatus = filterVehicle.rrStatus;
            this.division = filterVehicle.division;
            this.serviceCount = filterVehicle.serviceTypeSequence;
            // this.bayNo = filterVehicle.bayNo;
            // this.bayStartTime = filterVehicle.bayStartTime;
            // this.bayEndTime = filterVehicle.bayEndTime;
          } else { //if search is number then select default vehicle
            this.selectedChasis = this.serviceDetail[0].vin
            this.selectedRegNumber = this.serviceDetail[0].registrationNumber
            this.selectedVehicle = this.serviceDetail[0];
            this.selectedService = this.serviceDetail[0].typeOfService;
            this.selectedWorkShop = this.serviceDetail[0].workshopCode || this.selectedWorkShop;
            this.rrStatus = this.serviceDetail[0].rrStatus;
            this.division = this.serviceDetail[0].division;
            this.serviceCount = this.serviceDetail[0].serviceTypeSequence;
            //this.bayNo = this.serviceDetail[0].bayNo;
            //this.bayStartTime = this.serviceDetail[0].bayStartTime;
            //this.bayEndTime = this.serviceDetail[0].bayEndTime;
          }
          // if(this.rrStatus == 'YES') {
          //   this.rrDropdown = true;
          //   this.miscellaneousService = this.miscellaneousServices[0].value;
          // }

          this.getWorkshopAppointmentFlag(this.selectedWorkShop, this.workshopCodeFlag);
          //if(this.selectedWorkShop == )
          // if(this.division == "LMD") {
          //   this.serviceHours = 1;
          //   this.serviceMintus = 30;
          // } else {
          //   this.serviceHours = 2;
          //   this.serviceMintus = 0;
          // }

          if(this.serviceCount >= 0) {
            if(this.serviceCount % 2 == 1) {
              this.serviceHours = 1;
              this.serviceMintus = 30;
            } else {
              this.serviceHours = 4;
              this.serviceMintus = 0;
            }
          }
          // this.fertCode = this.selectedVehicle.fertCode;
          // if (this.selectedVehicle.typeOfService) {
          //   if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          //     this.showBay = true;
          //   } else {
          //     this.showBay = false;
          //   }
          // } else {
          //   this.showBay = true;
          // }
          // this.buildServiceForm();
          // if (this.fertCode && this.showBay) {
          //   this.getFertPrice(this.selectedWorkShop, this.fertCode);
          // }
        } else {
          this.toastr.error(data['message'], "Error");
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: onVehicleChange
  * purpose: To update selected vehicle data
  * @param {any} selectedVehicle - selected vehicle
  * @param {string} type - selected vehicle type
  * * @param {FormGroupDirective} formDirective - form directive
  */
  onVehicleChange(selectedVehicleNo: any, type: string, formDirective: FormGroupDirective) {
    if (type === 'V') {//fetch data of selected vehicle from radio btn- type vin
      this.selectedVehicle = this.serviceDetail.filter(vehicle => vehicle.vin == selectedVehicleNo)[0];
      this.selectedChasis = selectedVehicleNo;
    } else {//fetch data of selected vehicle from radio btn- type vin
      this.selectedVehicle = this.serviceDetail.filter(vehicle => vehicle.registrationNumber == selectedVehicleNo)[0];
      this.selectedRegNumber = selectedVehicleNo;
    }

    // this.serviceDetail = [];
    // this.selectedVehicle = '';
    // this.userService.getServiceDetail(this.customerDetails[0].customerCode, this.userId, selectedVehicleNo).subscribe(
    //   data => {
    //     if (data["responseCode"] == 0) {
    //       this.serviceDetail = data['responseData'];
    //       this.selectedVehicle = this.serviceDetail[0];
    //       localStorage.setItem("selectedVin",this.selectedVehicle.vin);
          this.selectedWorkShop = this.selectedVehicle.workshopCode || this.selectedWorkShop;
          this.fertCode = this.selectedVehicle.fertCode;
          this.serviceCount = this.selectedVehicle.serviceTypeSequence
          // if (this.selectedVehicle.typeOfService) {
          //   let serviceType = this.selectedVehicle.typeOfService.split(' - ')[0];
          //   if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
          //     this.showBay = true;
          //   } else {
          //     this.showBay = false;
          //   }
          // } else {
          //   this.showBay = true;
          // }
          if (this.workshopAppointmentFlag == "true") {
            // if(this.selectedVehicle.typeOfService) {
            //   let serviceType = this.selectedVehicle.typeOfService.split(' - ')[0];
              //if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
                this.showBay = true;
              // } else {
              //   this.showBay = false;
              // }
            // } else {
            //   this.showBay = false;
            // }
          } else {
            this.showBay = false;
          }
          this.resetServiceForm(formDirective);
          this.buildServiceForm();
          if(this.showBay) {
            this.getBayVisibility();
          }
          if (this.selectedVehicle.fertCode && this.showBay) {
            this.getFertPrice(this.selectedWorkShop, this.fertCode);
          }
      //   }
      // })
  }

  /**
  * Name: buildCustDataForm
  * purpose: To create customer data form
  */
  buildCustDataForm() {
    this.custDataForm = this.fb.group({
      custContact: [this.customerDetails[0].customerContactNo, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      fleetMangName: [""],
      fleetMangContact: ["", [Validators.minLength(10), Validators.maxLength(10)]]
    });
  }

  /**
  * Name: hasCustDataError
  * purpose: To check if customer form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasCustDataError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) &&
      !control.valid
    );
  }

  /**
  * Name: saveCustomer
  * purpose: To save customer updated details
  */
  saveCustomer() {
    let f = this.custDataForm;
    this.submitted = true;
    if (f.valid) {
      let custData = {
        creId: this.userId,
        custCode: this.customerDetails[0].customerCode,
        custContactNo: f.value.custContact || '',
        fleetContactNo: f.value.fleetMangContact || '',
        fleetName: f.value.fleetMangName || '',
        userId: this.userId
      }
      this.spinner = true;
      this.commonService.saveInboundCustomer(custData).subscribe(
        data => {
          if (data['responseCode'] == 0) {
            this.getFleetDetails(this.customerDetails[0].customerCode);
            this.custDataForm.controls['fleetMangName'].setValue("");
            this.custDataForm.controls['fleetMangContact'].setValue("");
            this.toastr.success(data['message'], "Success");
          } else {
            this.toastr.error(data['message'], "Error");
          }
          this.spinner = false;
        }, err => {
          this.spinner = false;
          this.toastr.error("Something went wrong, Please try again.", "Error");
        });
    }
  }

  /**
  * Name: build service data Form
  * purpose: To create vehicle service info form
  */
  buildServiceForm() {
    this.dateTimeExample = this.selectedVehicle.bookingDate ? new Date(this.selectedVehicle.bookingDate) : this.dateTimeExample;
    this.disableServiceType = this.selectedVehicle.typeOfService ? true : false;
    this.rrDropdown = this.rrStatus == "YES" ? true : false;
    let missService = this.rrStatus == "YES" ? this.miscellaneousServices[0].value : this.miscellaneousService;

    if (this.showBay) {

      let packageId = this.packagelist.length ? this.packagelist[0].packageId : '';
      this.serviceForm = this.fb.group({
        serviceType: [this.selectedVehicle.typeOfService],
        miscellaneousService: [missService],
        serviceMileage: [this.selectedVehicle.milage],
        serviceDealer: [this.selectedWorkShop, Validators.required],
        serviceDateTime: [this.dateTimeExample, Validators.required],
        bayStartTime: [this.bayMinToday],
        package: [packageId],
        serviceComment: [this.selectedVehicle.comments]
      });
    } else {
      this.serviceForm = this.fb.group({
        serviceType: [this.selectedVehicle.typeOfService],
        miscellaneousService: [missService],
        serviceMileage: [this.selectedVehicle.milage],
        serviceDealer: [this.selectedWorkShop, Validators.required],
        serviceDateTime: [this.dateTimeExample, Validators.required],
        serviceComment: [this.selectedVehicle.comments]
      });
    }
  }

  /**
    * Name: hasDateError
    * purpose: To check if service date has any error
    * @param {any} control - form control
    * @return {boolean} flag to determine if form is valid.
    */
  hasDateError(control: any): boolean {
    let error = false;
    let todayDate = this.datePipe.transform(this.today, "yyyy-MM-dd");
    let bookingDate = this.datePipe.transform(control.value, "yyyy-MM-dd")
    if (todayDate == bookingDate) {
      error = true;
    } else {
      error = false;
    }
    return error;
  }

  /**
  * Name: hasServiceError
  * purpose: To check if service data form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasServiceError(control: any): boolean {

    this.todayDate = new Date(this.datePipe.transform(this.today, "yyyy-MM-dd"));
    this.bookingDate = new Date(this.datePipe.transform(this.serviceForm.value.serviceDateTime, "yyyy-MM-dd"));
    return (
      control &&
      (this.submittedService || control.touched || control.dirty) &&
      !control.valid
    );
  }

  /**
  * Name: resetServiceForm
  * purpose: To reset service form data
  * @param {FormGroupDirective} formDirective - form directive
  */
  resetServiceForm(formDirective: FormGroupDirective) {
    if (formDirective) {
      formDirective.resetForm();
    }
    this.serviceForm.reset();
    Object.keys(this.serviceForm.controls).forEach(key => {
      this.serviceForm.controls[key].setErrors(null)
    });
  }

  /**
  * Name: saveService
  * purpose: To save vehicle service updated details
  * @param {boolean} close - flag to close search view
  * @param {FormGroupDirective} formDirective - form directive
  */
  saveService(close: boolean, formDirective: FormGroupDirective) {
    let f = this.serviceForm;
    this.submittedService = true;
    if (f.valid) {
      if (this.showBay == true && this.showBay1 == false) {
        let serviceDateTime = this.datePipe.transform(f.value.serviceDateTime, "yyyy-MM-ddTHH:mm:ssZ");
        let bookingDate = this.datePipe.transform(this.selectedVehicle.bookingDate, "yyyy-MM-ddTHH:mm:ssZ");
        let dueDate = this.datePipe.transform(this.selectedVehicle.serviceDueDate, "yyyy-MM-dd");
        let serviceType = '';
        if (f.value.serviceType) {
          this.serviceTypes.forEach(type => {
            if (type.value == f.value.serviceType) {
              serviceType = type.code;
            }
          });
        }
        let miscellaneousService = '';
        if (f.value.miscellaneousService) {
          this.miscellaneousServices.forEach(type => {
            if (type.value == f.value.miscellaneousService) {
              miscellaneousService = type.code;
            }
          });
        }
        let bay: string;
        let bayEndTime: any;
        //bay time selection
        if (serviceDateTime && this.showBay && f.value["bayStartTime"] != null) {
          //bay time
          let selectedDate = this.datePipe.transform(serviceDateTime, "yyyy-MM-dd");
          let selectedTime = this.datePipe.transform(f.value["bayStartTime"], "HH:mm:ss");
          let bayDateTime = new Date(selectedDate + 'T' + selectedTime);
          //service time data data
          serviceDateTime = this.datePipe.transform(bayDateTime, "yyyy-MM-ddTHH:mm:ssZ");

          //bayendtime
          this.bayEndTime = bayDateTime.setHours(bayDateTime.getHours() + this.serviceHours);
          this.bayEndTime = bayDateTime.setMinutes(bayDateTime.getMinutes() + this.serviceMintus);
          this.bayEndTime = this.datePipe.transform(this.bayEndTime, "HH:mm:ss");
        }
        if (this.showBay && f.value.serviceDateTime) {
          bay = this.selectedBayNo;
          bayEndTime = this.bayEndTime;
        } else {
          bay = '';
          // let time = this.datePipe.transform(new Date(), "yyyy-MM-dd") + "T00:00:00+0000";
          // bayEndTime = this.datePipe.transform(time, "HH:mm:ss");
          bayEndTime = "00:00:00";
        }
        let serviceData = {
          "creId": this.userId,
          "custCode": this.customerDetails[0].customerCode,
          "vin": this.selectedVehicle.vin,
          "serviceDueDate": dueDate || this.datePipe.transform(f.value.serviceDateTime, "yyyy-MM-dd"),
          "driverName": this.selectedVehicle.driverName || '',
          "driverContactNo": this.selectedVehicle.driverContactNo || '',
          "typeOfService": serviceType || '',
          "milage": f.value.serviceMileage || '',
          "dealerWorkshopName": f.value.serviceDealer,
          "callStatusCode": this.selectedVehicle.callStatusCode || '',
          "bookingDate": serviceDateTime || bookingDate,
          "serviceReason": this.callReason,
          "comments": f.value.serviceComment || '',
          "userId": this.userId,
          "bay": bay,
          "bayEndTime": bayEndTime,
          "misServiceType": miscellaneousService
        }
        this.spinner = true;
        this.commonService.saveServiceData(serviceData).subscribe(
          data => {
            if (data['responseCode'] == 0) {
              this.toastr.success(data['message'], "Success");
              //this.sendBookingSMS(serviceData);
              if (this.serviceDetail.length > 1 && !close) {//select new vehicle in case of multiple vin
                let newVehicle = this.serviceDetail.filter(vehicle => vehicle.vin != this.selectedVehicle.vin)[0];
                if (newVehicle && newVehicle.vin) {
                  this.onVehicleChange(newVehicle.vin, 'V', formDirective);
                }
              } else {
                this.resetServiceForm(formDirective);
                this.clearSearch();
              }
              this.submittedService = false;
            } else {
              this.submittedService = false;
              this.toastr.error(data['message'], "Error");
            }
            this.spinner = false;
          }, err => {
            this.spinner = false;
            this.submittedService = false;
            this.toastr.error("Something went wrong, Please try again.", "Error");
          });
      }
      else {
        let dueDate
        let serviceDateTime = this.datePipe.transform(f.value.serviceDateTime, "yyyy-MM-ddTHH:mm:ssZ");
        let bookingDate = this.datePipe.transform(this.selectedDoorstepVehicle.bookingDate, "yyyy-MM-ddTHH:mm:ssZ");
        if(this.selectedDoorstepVehicle.serviceDueDate != null){
         dueDate = this.datePipe.transform(this.selectedDoorstepVehicle.serviceDueDate, "yyyy-MM-dd");
      }
      else{
         dueDate = this.datePipe.transform(this.selectedVehicle.serviceDueDate, "yyyy-MM-dd");
      }
        let serviceType = '';
        if (f.value.serviceType) {
          this.serviceTypes.forEach(type => {
            if (type.value == f.value.serviceType) {
              serviceType = type.code;
            }
          });
        }
        let serviceData = {
          "creId": this.userId,
          "custCode": this.customerDetails[0].customerCode,
          "vin": this.selectedDoorstepVehicle.vin,
          "serviceDueDate": dueDate || this.datePipe.transform(f.value.serviceDateTime, "yyyy-MM-dd"),
          "driverName": this.selectedDoorstepVehicle.driverName || '',
          "driverContactNo": this.selectedDoorstepVehicle.driverContactNo || '',
          "typeOfService": serviceType || '',
          "mileage": f.value.serviceMileage || '',
          "dealerWorkshopCode": f.value.serviceDealer,
          "callStatusCode": this.selectedDoorstepVehicle.callStatusCode || '',
          "bookingDate": serviceDateTime || bookingDate,
          "address": f.value.address || '',
          "pincode": f.value.pincode || '',
          "distance": f.value.location || '',
          "additionalService": f.value.additionalServiceRequired || '',
          "paymentMethod": f.value.payment || '',
          "comments": f.value.serviceComment || '',
        }
        this.spinner = true;
        this.commonService.saveDoorstepServiceData(serviceData).subscribe(
          data => {
            if (data['responseCode'] == 0) {
              this.toastr.success(data['message'], "Success");
              //this.sendBookingSMS(serviceData);
              if (this.doorstepServiceDetail.length > 1 && !close) {//select new vehicle in case of multiple vin
                let newVehicle = this.doorstepServiceDetail.filter(vehicle => vehicle.vin != this.selectedDoorstepVehicle.vin)[0];
                if (newVehicle && newVehicle.vin) {
                  this.onVehicleChange(newVehicle.vin, 'V', formDirective);
                }
              } else {
                this.resetServiceForm(formDirective);
                this.clearSearch();
              }
              this.submittedService = false;
            } else {
              this.submittedService = false;
              this.toastr.error(data['message'], "Error");
            }
            this.spinner = false;
          }, err => {
            this.spinner = false;
            this.submittedService = false;
            this.toastr.error("Something went wrong, Please try again.", "Error");
          });
      }
    } else {
      this.submittedService = false;
    }
  }

  /**
   * Name: sendBookingSMS
   * purpose: To send booking sms
   */
  sendBookingSMS(bookingData: any): void {
    this.spinner = true;
    let bookingDate = this.datePipe.transform(bookingData.bookingDate, "yyyy-MM-dd");
    let bookingTime = this.datePipe.transform(bookingData.bookingDate, "yyyy-MM-ddTHH:mm:ssZ");
    let request = {
      bkStatus: 'B',
      bkTime: bookingTime || '',
      bkdate: bookingDate || '',
      contactNo: this.customerDetails[0].customerContactNo || '',
      custName: this.customerDetails[0].customerName || '',
      regNo: this.selectedVehicle.registrationNumber || '',
      vin: this.selectedVehicle.vin || ''
    }
    this.workShops.forEach(workshop => {
      if (workshop.workshopCode == this.selectedWorkShop) {
        request['wSAddress'] = workshop.workshopAddress || '';
        request['wSManager'] = workshop.contactNo || '';
      }
    });
    this.commonService.sendBookingSMS(request).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.spinner = false;
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: openCustomer360
  * purpose: To open customer360 popup
  * @param {string} custId - customer id
  */
  openCustomer360(custId: string) {
    this.dialog.open(Customer360DialogComponent, {
      width: '70%',
      data: { customerCode: custId }
    });
  }

  /**
  * Name: clearSearch
  * purpose: To clear current search data
  */
  clearSearch() {
    this.customerChassisList = [];
    this.customerNumberList = [];
    this.customerDetails = [];
    this.fleetDetail = [];

    this.serviceDetail = [];
    this.selectedVehicle = [];
    this.selectedDoorstepVehicle = [];
    this.selectedService = '';
    this.vinList = [];
    this.selectedVin = '';
    this.miscellaneousServices = [
      { value: 'RUNNING REPAIR', type: 'RUNNING REPAIR/QUICK SERVICE', code: 'RR' },
      { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
    ];
    this.miscellaneousService = '';

    this.selectedChasis = '';
    this.selectedRegNumber = '';
    this.selectedWorkShop = (this.workShops && this.workShops.length) ? this.workShops[0].workshopCode : '';

    this.searchChassis.setValue('');
    this.searchNumber.setValue('');
    this.searchRegisterationNo.setValue('');
    this.searchChassis.enable();
    this.searchNumber.enable();
    this.searchRegisterationNo.enable();
    if (this.serviceForm) {
      this.serviceForm.reset();
    }
    if (this.custDataForm) {
      this.custDataForm.reset();
    }
    //this.rrDropdown = false;
    this.commentFlag = false;
  }

  /**
   * Name: getWorkshopBay
   * purpose: To getWorkshopBay
   */
  getWorkshopBay(): void {
    this.commonService.getWorkshopBay(this.userId).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.assignedBay = res["responseData"];
        this.bayStartTime = this.assignedBay[0].startTime;
      } else {
        //this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  /**
   * Name: getBayVisibility
   * purpose: To getBayVisibility
   */
  getBayVisibility(): void {
    let workShopCode = this.serviceForm.value.serviceDealer;
    let selectedDate = this.datePipe.transform(this.serviceForm.value.serviceDateTime, "yyyy-MM-dd");
    this.bayLayout = [];
    this.chartData = [];
    this.commonService.getBayVisibility(workShopCode, selectedDate).subscribe(res => {
      if (res["responseCode"] == 0) {
        if (res["responseData"].length) {
          res["responseData"].sort(function (a, b) {
            let aStartTime = new Date(selectedDate + 'T' + a.startTime);
            let bStartTime = new Date(selectedDate + 'T' + b.startTime);

            var aMin = aStartTime.getMinutes();
            var aHrs = aMin > 0 ? aMin / 60 : 0;
            let aTime = aStartTime.getHours() + aHrs;

            var bMin = bStartTime.getMinutes();
            var bHrs = bMin > 0 ? bMin / 60 : 0;
            let bTime = bStartTime.getHours() + bHrs;
            return aTime - bTime;
          });
        }

        var result = Object.assign([], res["responseData"]);

        //get assigned workshop details
        this.assignedBay.forEach(element => {
          if (element.workshopCode == workShopCode) {
            this.workShopBay = element;
          }
        });
        this.workShopBay.bayArea = Object.assign([], res["responseData"]);
        let totalNoBay = Number(this.workShopBay.totalNoBay);
        //set baylayout
        let bayList = [];
        for (let b = 1; b <= totalNoBay; b++) {
          var bay = result.filter(item => item.bay == b);
          bayList.push(bay);
        }
        this.selectedBay = Object.assign([], bayList[0]);
        this.selectedBayNo = bayList.length ? 1 : "";
        this.bayLayout = Object.assign([], bayList);

        //get bay details
        if(new Date(selectedDate + 'T' + this.workShopBay.startTime).getTime() <= this.today.getTime()) {
          this.bayMinToday = new Date();
          this.bayMaxToday = new Date(selectedDate + 'T' + this.workShopBay.endTime);
        } else {
          this.bayMinToday = new Date(selectedDate + 'T' + this.workShopBay.startTime);
          this.bayMaxToday = new Date(selectedDate + 'T' + this.workShopBay.endTime);
        }
        this.bayOpen = new Date(selectedDate + 'T' + this.workShopBay.startTime);
        this.bayClose = new Date(selectedDate + 'T' + this.workShopBay.endTime);
        this.serviceForm.controls.bayStartTime.setValue(this.bayMinToday);

        //get chart labels
        let startTime = this.checkHours(this.bayOpen);
        let endTime = this.checkHours(this.bayClose);

        this.chartOptions.scales.xAxes[0].ticks.min = startTime;
        this.chartOptions.scales.xAxes[0].ticks.max = endTime;

        //fill bay availability
        this.bayLayout.forEach(bayData => {
          let chartData: ChartDataSets[] = [];
          let chartLength = 0;
          let i = startTime;
          for (i; i <= endTime; i++) {
            let slot = {};
            slot['value'] = i;
            slot['available'] = true;

            bayData.some((element, index) => {
              //service time
              let serviceStart = new Date(selectedDate + 'T' + element.startTime);
              let serviceEnd = new Date(selectedDate + 'T' + element.endTime);

              //final service day hrs
              let serviceStartTime = this.checkHours(serviceStart);
              let serviceEndTime = this.checkHours(serviceEnd);

              let serVal = serviceEndTime - serviceStartTime;

              if (i >= serviceStartTime) {
                slot['available'] = false;
                let chartVal = serVal;
                if (chartVal > 0) {
                  i = chartData.length ? (i + chartVal - 1) : serviceEndTime - 1;
                  chartVal = chartData.length ? chartVal : serviceStartTime + chartVal;
                  let data: ChartDataSets = {
                    data: [chartVal],
                    stack: 'a',
                    label: 'Occupied',
                    backgroundColor: '#e64243',
                    hoverBackgroundColor: '#e64243',
                    borderSkipped: 'left',
                    borderWidth: 1,
                    borderColor: "#e64243",
                    barThickness: 8
                  }
                  chartLength = chartLength + chartVal;
                  chartData.push(data);
                  bayData.splice(index, 1);
                }
                return true;
              } else {
                let chartVal = serviceStartTime - i;
                if (chartVal > 0) {
                  i = chartData.length ? (i + chartVal - 1) : serviceStartTime - 1;
                  chartVal = chartData.length ? chartVal : serviceStartTime;
                  let data: ChartDataSets = {
                    data: [chartVal],
                    stack: 'a',
                    label: 'Available',
                    backgroundColor: '#d3d3d3',
                    hoverBackgroundColor: '#d3d3d3',
                    borderSkipped: 'left',
                    borderWidth: 1,
                    borderColor: "#d3d3d3",
                    barThickness: 8
                  }
                  chartLength = chartLength + chartVal;
                  chartData.push(data);
                  return true;
                }
              }
            });
            if (bayData.length == 0) {
              let chartVal = endTime - chartLength;
              let data: ChartDataSets = {
                data: [chartVal],
                stack: 'a',
                label: 'Available',
                backgroundColor: '#d3d3d3',
                hoverBackgroundColor: '#d3d3d3',
                borderSkipped: 'left',
                borderWidth: 1,
                borderColor: "#d3d3d3",
                barThickness: 8
              }
              chartData.push(data);
              break;
            }
          }
          this.chartData.push(chartData);
        });
        if (this.serviceForm.value['bayStartTime']) {
          this.checkAvailability();
        }
      } else {
        this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  /**
   * Name: selectBay
   * purpose: To selectBay
   */
  selectBay(bay: any) {
    this.bayError = false;
    this.selectedBay = this.workShopBay.bayArea.filter(item => item.bay == (bay.value + 1));
    this.selectedBayNo = bay.value + 1;
  }

  /**
   * Name: checkAvailability
   * purpose: To checkAvailability
   */
  checkAvailability(): void {
    this.bayError = false;
    let serviceTime = 0;
    // if(this.division == "LMD") {
    //   serviceTime = 1.5;
    // } else {
    //   serviceTime = 2;
    // }

    if(this.serviceCount>=0){
      if(this.serviceCount % 2 == 1){
        serviceTime = 1.5;
      }else{
        serviceTime = 4;
      }
    }
    let bayOpen = this.checkHours(this.bayOpen);
    let bayClose = this.checkHours(this.bayClose);
    let bayMinToday = this.checkHours(this.bayMinToday);
    let bayMaxToday = this.checkHours(this.bayMaxToday);
    let selectedTime = this.checkHours(new Date(this.serviceForm.value['bayStartTime']));
    let selectedEndTime = selectedTime + serviceTime;
    if (this.selectedBay.length) {
      this.selectedBay.some(element => {
        let date = this.datePipe.transform(this.serviceForm.value['bayStartTime'], "yyyy-MM-dd");
        let startDate = new Date(date + 'T' + element.startTime);
        let endDate = new Date(date + 'T' + element.endTime);
        let startTimeS = this.checkHours(startDate);
        let endTimeS = this.checkHours(endDate);
        if((selectedEndTime > bayMaxToday) || (selectedTime < bayMinToday)) {
          this.bayError = true;
          return true;
        }
        if ((selectedTime >= startTimeS && selectedTime < endTimeS) ||
          (selectedEndTime > startTimeS && selectedEndTime <= endTimeS) ||
          (selectedEndTime > bayClose) || (selectedTime < bayOpen) ||
          (selectedTime <= startTimeS && selectedEndTime >= endTimeS)) {
          this.bayError = true;
          return true;
        }
      });
    } else {
      let selectedTime = this.checkHours(new Date(this.serviceForm.value['bayStartTime']));
      let selectedEndTime = selectedTime + serviceTime;
      if ((selectedEndTime > bayClose) || (selectedTime < bayOpen)) {
        this.bayError = true;
      }
      if((selectedEndTime > bayMaxToday) || (selectedTime < bayMinToday)) {
        this.bayError = true;
      }
    }
  }

  /**
   * Name: checkHours
   * purpose: To checkHours
   */
  checkHours(selectedTime) {
    var startMin = selectedTime.getMinutes();
    var hrsOpen = startMin > 0 ? startMin / 60 : 0;
    let startTime = selectedTime.getHours() + hrsOpen;
    return startTime;
  }

  /**
   * Name: getFertPrice
   * purpose: To getFertPrice
   */
  getFertPrice(workShopCode: string, fertCode: string): void {
    this.commonService.getFertPrice(workShopCode, fertCode).subscribe(res => {
      if (res["responseCode"] == 0) {
        this.packagelist = res["responseData"];
        this.packagelist.forEach(element => {
          element.fert = Math.round(Number(element.fert) * 100 + Number.EPSILON) / 100;
        });
        //this.serviceHours = this.packagelist.length ? this.packagelist[0].fert : 2;
        // if(this.showBay) {
        //   this.getBayVisibility();
        // }
        this.serviceForm.controls["package"].setValue(this.packagelist[0].packageId);
      } else {
        //this.serviceHours = 2;
        //this.getBayVisibility();
        //this.toastr.error(res["message"], "Error");
        this.spinner = false;
      }
    }, error => {
      //this.toastr.error(error, "Error");
      this.spinner = false;
    });
  }

  setPackage(packageId) {
    // this.packagelist.forEach(element => {
    //   if (element.packageId == packageId) {
    //     this.serviceHours = element.fert || 2;
    //   }
    // });
    if (this.serviceForm.value['bayStartTime']) {
      this.checkAvailability();
    }
  }

  filterTriggered(event: any, formDirective: FormGroupDirective): void {
    this.miscellaneousService = "";
    this.miscellaneousService = event.value;
    if ((event && event.value)) {
      if (event.value == "DOORSTEP SERVICE") {
        this.showBay1 = true;
        this.showBay = false;
        this.resetServiceForm(formDirective);
        this.getDoorstepCustomerVinDetails(this.customerDetails[0].customerCode, this.selectedVin);
        this.buildDoorstepServiceForm();

      }
      else {
        this.showBay1 = false;
        this.showBay = true;
        this.resetServiceForm(formDirective);
        if(this.selectedService != null){
          this.miscellaneousServices = [
            { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
          ];
        }
        this.buildServiceForm();
        if (this.selectedVehicle.fertCode && (this.showBay && !this.showBay1)) {
          this.getFertPrice(this.selectedWorkShop, this.fertCode);
        }
      }
      this.commentFlag = true;
    }
  }

  getWorkshopAppointmentFlag(workShopCode: string, flag: any) {
    this.packagelist = [];
    this.commonService.getWorkshopAppointmentFlag(workShopCode)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.workshopAppointmentFlag = res['responseData'][0].appointmentFlag;
          this.fertCode = this.selectedVehicle.fertCode;
          if (this.workshopAppointmentFlag == "true") {
            // if(this.selectedVehicle.typeOfService) {
            //   let serviceType = this.selectedVehicle.typeOfService.split(' - ')[0];
              // if (serviceType == 'FS1' || serviceType == 'FS2' || serviceType == 'FS3' || serviceType == 'ECS' || serviceType == 'PMS') {
                this.showBay = true;
              // } else {
              //   this.showBay = false;
              // }
            // } else {
            //   this.showBay = false;
            // }
          } else {
            this.showBay = false;
            this.selectedBayNo = "";
          }
          // if(flag) {
            this.selectedWorkShop = workShopCode;
            this.buildServiceForm();
            if (this.showBay) {
              this.getBayVisibility();
            }
          // }
          if (this.fertCode && this.showBay) {
            this.getFertPrice(this.selectedWorkShop, this.fertCode);
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  getDoorstepCustomerVinDetails(customerCode: string, vin: string) {
    this.spinner = true;
    this.userService.getDoorstepServiceDetail(customerCode, this.userId, vin).subscribe(res => {
      if (res['responseCode'] == 0 && res['responseData'] != undefined) {
        this.doorstepServiceDetail = res['responseData'];
        if (this.searchChassis.value) {//if search is chasis then select default vehicle
          let filterVehicle = this.doorstepServiceDetail.filter(vehicle => vehicle.vin == this.searchChassis.value)[0];
          this.selectedChasis = filterVehicle.vin;
          this.selectedRegNumber = filterVehicle.registrationNumber
          this.selectedDoorstepVehicle = filterVehicle;
          if (filterVehicle.serviceType != null) {

            this.selectedService = filterVehicle.serviceType;
            this.selectedWorkShop = filterVehicle.workshopCode || this.selectedWorkShop;
            this.selectedVehicleType = 1;
            this.division = filterVehicle.division;
            this.serviceCount = filterVehicle.serviceTypeSequence;
            this.buildDoorstepServiceForm();
            this.miscellaneousServices = [
              { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
            ];
          }
          else {
            this.dateTimeExample = this.selectedVehicle.bookingDate ? new Date(this.selectedVehicle.bookingDate) : this.dateTimeExample;
            this.disableServiceType = this.selectedVehicle.typeOfService ? true : false;
            this.rrDropdown = this.rrStatus == "YES" ? true : false;
            let missService = this.rrStatus == "YES" ? this.miscellaneousServices[0].value : "";
           if(this.selectedVehicle.typeOfService != null){
            this.miscellaneousServices = [
              { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
            ];
          }
          else{
            this.miscellaneousServices = [
              { value: 'RUNNING REPAIR', type: 'RUNNING REPAIR/QUICK SERVICE', code: 'RR' },
              { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
            ];
          }
            this.serviceForm = this.fb.group({
              serviceType: [this.selectedVehicle.typeOfService],
              miscellaneousService: [this.miscellaneousService],
              serviceMileage: [this.selectedVehicle.milage],
              serviceDealer: [this.selectedWorkShop, Validators.required],
              serviceDateTime: [this.dateTimeExample, Validators.required],
              serviceComment: [this.selectedVehicle.comments],
              address: ["",Validators.required],
              pincode: ["",Validators.required],
              location: ["",Validators.required],
              payment: ["",Validators.required],
              additionalServiceRequired: ["",Validators.required]
            });
          }

          // this.bayNo = filterVehicle.bayNo;
          // this.bayStartTime = filterVehicle.bayStartTime;
          // this.bayEndTime = filterVehicle.bayEndTime;
        } else if (this.searchRegisterationNo.value) {//if search is registrationNumber then select default vehicle
          let filterVehicle = this.serviceDetail.filter(vehicle => vehicle.registrationNumber == this.searchRegisterationNo.value)[0];
          this.selectedChasis = filterVehicle.vin
          this.selectedRegNumber = filterVehicle.registrationNumber
          this.selectedDoorstepVehicle = filterVehicle;
          if (filterVehicle.serviceType != null) {

            this.selectedService = filterVehicle.serviceType;
            this.selectedWorkShop = filterVehicle.workshopCode || this.selectedWorkShop;
            this.selectedVehicleType = 2;
            this.division = filterVehicle.division;
            this.serviceCount = filterVehicle.serviceTypeSequence;
            this.buildDoorstepServiceForm();
            this.miscellaneousServices = [
              { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
            ];

          }
          else {
            this.dateTimeExample = this.selectedVehicle.bookingDate ? new Date(this.selectedVehicle.bookingDate) : this.dateTimeExample;
            this.disableServiceType = this.selectedVehicle.typeOfService ? true : false;
            this.rrDropdown = this.rrStatus == "YES" ? true : false;
            let missService = this.rrStatus == "YES" ? this.miscellaneousServices[0].value : "";
            if(this.selectedVehicle.typeOfService != null){
              this.miscellaneousServices = [
                { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
              ];
            }
            else{
              this.miscellaneousServices = [
                { value: 'RUNNING REPAIR', type: 'RUNNING REPAIR/QUICK SERVICE', code: 'RR' },
                { value: 'DOORSTEP SERVICE', type: 'DOORSTEP SERVICE', code: 'DS' },
              ];
            }

            this.serviceForm = this.fb.group({
              serviceType: [this.selectedVehicle.typeOfService],
              miscellaneousService: [this.miscellaneousService],
              serviceMileage: [this.selectedVehicle.milage],
              serviceDealer: [this.selectedWorkShop, Validators.required],
              serviceDateTime: [this.dateTimeExample, Validators.required],
              serviceComment: [this.selectedVehicle.comments],
              address: ["",Validators.required],
              pincode: ["",Validators.required],
              location: ["",Validators.required],
              payment: ["",Validators.required],
              additionalServiceRequired: ["",Validators.required]
            });


          }
          // this.bayNo = filterVehicle.bayNo;
          // this.bayStartTime = filterVehicle.bayStartTime;
          // this.bayEndTime = filterVehicle.bayEndTime;
        } else { //if search is number then select default vehicle
          this.selectedChasis = this.serviceDetail[0].vin
          this.selectedRegNumber = this.serviceDetail[0].registrationNumber
          this.selectedDoorstepVehicle = this.serviceDetail[0];
          this.selectedService = this.serviceDetail[0].serviceType;
          this.selectedWorkShop = this.serviceDetail[0].workshopCode || this.selectedWorkShop;
          this.rrStatus = this.serviceDetail[0].rrStatus;
          this.division = this.serviceDetail[0].division;
          this.serviceCount = this.serviceDetail[0].serviceTypeSequence;
          //this.bayNo = this.serviceDetail[0].bayNo;
          //this.bayStartTime = this.serviceDetail[0].bayStartTime;
          //this.bayEndTime = this.serviceDetail[0].bayEndTime;
        }
      }
      else {
        this.toastr.error(res['message'], "Error");
      }
      this.spinner = false;
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  buildDoorstepServiceForm() {
    this.dateTimeExample = this.selectedDoorstepVehicle.bookingDate ? new Date(this.selectedDoorstepVehicle.bookingDate) : this.dateTimeExample;
    this.disableServiceType = this.selectedDoorstepVehicle.serviceType ? true : false;

    this.serviceForm = this.fb.group({
      serviceType: [this.selectedDoorstepVehicle.serviceType],
      miscellaneousService: [this.miscellaneousService],
      serviceMileage: [this.selectedDoorstepVehicle.currentMileage],
      serviceDealer: [this.selectedWorkShop, Validators.required],
      serviceDateTime: [this.dateTimeExample, Validators.required],
      serviceComment: [this.selectedDoorstepVehicle.comments],
      address: ["",Validators.required],
      pincode: ["",Validators.required],
      location: ["",Validators.required],
      payment: ["",Validators.required],
      additionalServiceRequired: ["",Validators.required]
    });
  }


  /**
  * Name: saveServiceData
  * purpose: To save vehicle service updated details
  * @param {boolean} close - flag to close search view
  * @param {FormGroupDirective} formDirective - form directive
  */
  saveServiceData(close: boolean, formDirective: FormGroupDirective) {

    let today : Date = new Date();
    let todayDate = new Date(this.datePipe.transform(today, "yyyy-MM-dd"))
    let booking = new Date(this.datePipe.transform(this.serviceForm.value.serviceDateTime, "yyyy-MM-dd"))

      if(this.workshopAppointmentFlag == "true" && this.selectedBayNo != '') {
        if(booking > todayDate) {
          this.saveService(close, formDirective);
        } else {
          this.toastr.error("Booking not allow on current Date.", "Error");
        }
      }
      else if(this.workshopAppointmentFlag == "false" && this.selectedBayNo == '') {
        if(booking > todayDate) {
          this.saveService(close, formDirective);
        } else {
           this.toastr.error("Booking not allow on current Date.", "Error");
        }
      }
      else {
          this.toastr.error("Please select the Bay.", "Error");
      }
  }
}